import script from "./ResourcesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourcesPage.vue?vue&type=script&setup=true&lang=js"

import "./ResourcesPage.vue?vue&type=style&index=0&id=66e3d1b8&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./ResourcesPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e3d1b8"]])

export default __exports__